import { Button, Input, Textarea } from '@roger/ui-components';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';

interface Props {
  initialName: string;
  initialDescription: string;
  saving: boolean;
  onCancel: () => void;
  onSave: (details: { name: string; description: string }) => void;
}

export function SectionTemplateDetailsEdit({
  initialName,
  initialDescription,
  saving,
  onCancel,
  onSave,
}: Props) {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  const trimmedName = name.trim();
  const canSave = trimmedName.length > 0 && !saving;

  return (
    <div className='space-y-2'>
      <div className='space-y-1'>
        <label className='text-sm font-medium' htmlFor='tmpl-name'>
          Name
        </label>
        <Input
          id='tmpl-name'
          value={name}
          onChange={e => setName(e.target.value)}
          disabled={saving}
        />
      </div>
      <div className='space-y-1'>
        <label className='text-sm font-medium' htmlFor='tmpl-desc'>
          Description
        </label>
        <Textarea
          id='tmpl-desc'
          value={description}
          onChange={e => setDescription(e.target.value)}
          rows={3}
          disabled={saving}
        />
      </div>
      <div className='flex justify-end gap-2'>
        <Button
          type='button'
          variant='outline'
          size='sm'
          onClick={onCancel}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          type='button'
          size='sm'
          onClick={() =>
            onSave({ name: trimmedName, description: description.trim() })
          }
          disabled={!canSave}
        >
          {saving && (
            <Loader2 className='mr-2 h-4 w-4 animate-spin' aria-hidden />
          )}
          Save
        </Button>
      </div>
    </div>
  );
}
